/** Idioma fuente (§32). Los demás locales tipan contra este objeto. */
export const es = {
  "common.cancel": "Cancelar",
  "common.save": "Guardar",
  "common.saved": "Guardado",
  "common.create": "Crear",
  "common.delete": "Eliminar",
  "common.close": "Cerrar",
  "common.loading": "Cargando…",
  "common.optional": "opcional",
  "common.resize": "Arrastra para cambiar el ancho",
  "update.available": "Hay una versión nueva de la aplicación.",
  "update.reload": "Recargar",
  "common.chooseFile": "Subir imagen",
  "common.uploading": "Subiendo…",
  "common.remove": "Quitar",
  "common.orPasteUrl": "o pega un enlace",
  "common.copy": "Copiar",
  "common.copied": "Copiado",
  "common.search": "Buscar",
  "common.none": "Ninguna",
  "common.seconds": "{n} s",
  "common.minutes": "{n} min",
  "common.hours": "{n} h",
  "common.back": "Volver",
  "common.pickColor": "Elegir color",
  "common.eyedropper": "Cuentagotas",
  "common.hue": "Tono",
  "common.saturation": "Saturación",
  "common.lightness": "Claridad",

  "auth.tagline": "Tu comunidad, en tu servidor, sin funciones bajo llave.",
  "auth.point1": "Chat, voz, tu perfil a tu manera y tu «jugando a…»: todo gratis, siempre.",
  "auth.point2": "Invita con un enlace: tus amigos entran sin crear cuenta.",

  "welcome.title": "Ya estás dentro, {name}",
  "welcome.body":
    "Crea tu comunidad para invitar a tus compañeros, o entra a una que ya exista con un enlace de invitación.",
  "welcome.create": "Crear mi comunidad",
  "welcome.join": "Tengo una invitación",
  "welcome.later": "Ahora no",
  "welcome.phoneBody":
    "Todavía no estás en ninguna comunidad. Las encuentras en Explorar, la brújula de la barra de comunidades, o entra con un enlace de invitación.",
  "welcome.explore": "Explorar comunidades",
  "status.noCommunity": "Sin comunidad todavía",
  "phone.createTitle": "Crea tu usuario",
  "phone.createHint":
    "Elige cómo te verán los demás. Se guarda en este dispositivo y te acompaña a cada comunidad en la que entres.",
  "phone.createAction": "Entrar",
  "auth.login": "Entrar",
  "auth.register": "Crear cuenta",
  "auth.guest": "Entrar como invitado",
  "auth.username": "Nombre de usuario",
  "auth.usernameHint": "Minúsculas, números, punto, guion y guion bajo.",
  "auth.password": "Contraseña",
  "auth.showPassword": "Mostrar la contraseña",
  "auth.hidePassword": "Ocultar la contraseña",
  "auth.passwordHint":
    "Opcional, pero sin ella esta cuenta solo se recupera desde el equipo que hospeda. Si cambias de navegador o borras sus datos, tendrás que pedírselo a quien hospeda.",
  "auth.passwordMin": "Al menos {n} caracteres.",
  "auth.noPasswordWarning":
    "Sin contraseña, esta cuenta vive solo en este navegador. Puedes añadirla luego desde Ajustes.",
  "auth.displayName": "Nombre visible",
  "auth.noAccount": "¿Todavía sin cuenta?",
  "auth.haveAccount": "¿Ya tienes cuenta?",
  "auth.guestTitle": "Sin cuenta",
  "auth.guestHint":
    "Puedes hacer exactamente lo mismo que con cuenta: crear comunidades, canales, invitar y hablar. Añade contraseña cuando quieras, sin perder nada.",
  "auth.recoverTitle": "Cuentas de este equipo",
  "auth.recoverHint":
    "Estas cuentas no tienen contraseña. Como entras desde este equipo, puedes continuar sin escribir nada.",
  "auth.registrationClosed": "Este servidor tiene el registro cerrado.",
  "auth.deviceProfileUnknown":
    "Este servidor todavía no conoce tu perfil de este dispositivo. Entra con una invitación o desde Explorar.",
  "auth.chooseProfile": "¿Quién va a entrar?",
  "auth.chooseProfileHint": "Elige uno de los perfiles guardados en este equipo.",
  "auth.addProfile": "Añadir perfil",
  "auth.otherAccount": "Usar otra cuenta",
  "auth.profilePasswordTitle": "Hola de nuevo, {name}",
  "auth.profilePasswordHint": "Este perfil está protegido. Escribe tu contraseña para entrar.",
  "auth.createProfileHint": "Crea un perfil para esta persona en este equipo.",
  "auth.backToProfiles": "Volver a los perfiles",
  "auth.mfaTitle": "Código del autenticador",
  "auth.mfaHint":
    "Abre Google Authenticator y escribe los 6 dígitos de Distop. Si perdiste el teléfono, pide un código de recuperación en la VPS con sudo distop-admin-recovery.",
  "auth.mfaCode": "Código",
  "auth.mfaBack": "Volver a la contraseña",

  "start.title": "¿Qué quieres hacer?",
  "start.createUser": "Crear usuario",
  "start.createUserHint": "Pon tu nombre y entra a participar en comunidades.",
  "start.admin": "Entrar como admin de mi servidor",
  "start.adminHint": "Tu VPS o tu PC, por su dirección de Tailscale.",
  "start.address": "Dirección de tu servidor",
  "start.addressHint": "Empieza por https://, por ejemplo https://mi-vps.tu-red.ts.net",
  "start.addressInvalid": "La dirección tiene que empezar por https://",
  "start.notInstance": "En esa dirección no hay un servidor de Distop.",
  "start.connect": "Conectar",
  "start.back": "Volver",

  "security.title": "Seguridad del admin",
  "security.hintOff":
    "Protege la entrada como admin desde fuera: además de la contraseña, se pedirá un código de tu teléfono la primera vez en cada dispositivo.",
  "security.on": "Autenticador activado",
  "security.enable": "Activar autenticador",
  "security.reconfigure": "Configurar otro teléfono",
  "security.step1": "1. Instala Google Authenticator",
  "security.download": "Descargar la app en mi teléfono",
  "security.installed": "Ya la instalé",
  "security.downloadHint": "Escanea con la cámara del teléfono el QR que te toque.",
  "security.android": "Android",
  "security.iphone": "iPhone",
  "security.step2": "2. Escanea el código de Distop",
  "security.step2Hint": "En la app pulsa «+» y luego «Escanear un código QR». Si no puedes escanear, escribe esta clave:",
  "security.step3": "3. Escribe el código que muestra la app",
  "security.confirm": "Confirmar",
  "security.lostAll": "Si pierdes el teléfono, en la VPS ejecuta: sudo distop-admin-recovery",

  "setup.title": "Crea tu usuario",
  "setup.subtitle":
    "Ponte un nombre y entra: sin correos ni verificaciones. Tu comunidad la creas ya dentro, cuando quieras.",
  "setup.yourName": "Tu nombre",
  "setup.password": "Contraseña",
  "setup.passwordHint":
    "Opcional ahora. Sin ella solo se vuelve a entrar desde el equipo que hospeda; puedes ponerla cuando quieras desde Ajustes.",
  "setup.code": "Código de puesta en marcha",
  "setup.codeHint":
    "Está impreso en el terminal donde arrancaste el servidor. Se pide porque estás reclamándolo desde otro equipo.",
  "setup.start": "Poner en marcha",
  "setup.noPasswordWarning":
    "Sin contraseña, esta cuenta vive solo en este navegador. Si lo borras, pierdes el acceso de administración.",

  "backupPhrase.title": "Guarda la frase de tus copias",
  "backupPhrase.body":
    "Tu servidor cifra una copia cada día con esta frase. Sin ella no se puede restaurar ninguna, ni tú ni nadie. Guárdala ahora en tu gestor de contraseñas, fuera del servidor.",
  "backupPhrase.fallback": "Si cierras esto sin copiarla, sigue estando en el servidor, en /data/backup-passphrase.",
  "backupPhrase.saved": "Ya la he guardado",

  "instance.connecting": "Conectando…",
  "instance.online": "En línea",
  "instance.offline": "Sin conexión",
  "instance.reconnecting": "Reconectando…",
  "instance.status": "Tu servidor",
  "instance.uptime": "Encendido",
  "instance.memory": "Memoria",
  "instance.storage": "Almacenamiento",
  "instance.storageFree": "quedan {free} libres",
  "instance.purge": "Limpiar datos",
  "instance.purgeHint":
    "Vacía el historial para recuperar espacio en el disco: se borran los chats, fotos, GIF y archivos de todas las comunidades. Las comunidades se quedan, con sus miembros, roles, canales, emojis y avatares.",
  "instance.purgeWarning":
    "Esto borra PARA SIEMPRE todos los mensajes y sus archivos, de todas las comunidades de este servidor. No hay papelera ni forma de recuperarlos. Tu comunidad no se elimina: solo su historial.",
  "instance.purgeDo": "Borrar el historial para siempre",
  "instance.purgeDone": "Hecho: {messages} mensajes borrados y {mb} MB recuperados.",
  "instance.users": "Personas conectadas",
  "instance.version": "Versión",
  "serverUsage.title": "Consumo y configuración",
  "serverUsage.hint": "Lo que usa esta máquina y una proyección basada en los últimos siete días.",
  "serverUsage.profile": "Tipo de servidor",
  "serverUsage.profileHint": "Decisión explícita: no se adivina por tener un dominio o un túnel.",
  "serverUsage.personalPc": "PC personal o servidor de casa",
  "serverUsage.vpsCloud": "VPS o nube",
  "serverUsage.images": "Fotos",
  "serverUsage.videos": "Vídeos",
  "serverUsage.audio": "Audios",
  "serverUsage.files": "Otros archivos",
  "serverUsage.traffic7d": "Tráfico de 7 días",
  "serverUsage.projection": "Proyección a 30 días",
  "serverUsage.stack": "Stack",
  "serverUsage.risk": "La proyección supera el espacio libre. Conviene pasar vídeos o archivos a P2P o apagarlos.",
  "serverUsage.ok": "La proyección actual cabe en el espacio libre.",
  "instance.discovery": "Directorio público",
  "instance.discoveryOn": "Activado",
  "instance.discoveryOff": "Desactivado",
  "instance.offlineHelp":
    "La comunidad vive en el equipo de quien la hospeda. Si ese equipo está apagado, no hay servicio hasta que vuelva.",

  "connect.localUnavailable": "No se pudo abrir el servidor local de este dispositivo.",
  "connect.invalid": "Esa dirección no es válida. Solo se admiten direcciones http o https.",
  "connect.unreachable":
    "Ahí no responde nadie. Puede que el servidor de esa comunidad esté apagado, que el túnel se haya cerrado o que la dirección tenga una errata.",
  "connect.notInstance": "En esa dirección responde algo, pero no es un servidor de Distop.",
  "connect.hostHint":
    "Tu comunidad corre en este ordenador, dentro de la aplicación: tus datos se quedan contigo. Estará disponible mientras este equipo esté encendido, y la velocidad depende de tu conexión.",
  "connect.preparing": "Arrancando tu servidor…",
  "connect.preparingHint":
    "La primera vez se crea tu base de datos en este equipo. Tu comunidad y tus datos viven aquí, contigo.",
  "connect.autoFailed": "Tu servidor no pudo arrancar en este equipo.",
  "connect.hostMine": "Tu servidor en este equipo",
  "connect.changeInstance": "Cambiar de comunidad",

  "game.playing": "Jugando a {name}",
  "game.for": "desde hace {time}",
  "game.recent": "Juegos recientes",
  "game.duration": "{time} · {date}",

  "share.title": "Compartir tu comunidad",
  "share.address": "Dirección para invitar",
  "share.localOnly":
    "Ahora mismo tu servidor solo existe en este ordenador. Un enlace con esta dirección no le funcionará a nadie más.",
  "share.ready":
    "Tu servidor es alcanzable desde fuera. Las invitaciones ya usan esta dirección.",
  "share.createLink": "Crear enlace público",
  "share.autostart": "Abrir el enlace público al arrancar",
  "share.autostartHint":
    "Tu comunidad será accesible desde internet mientras la aplicación esté abierta. Si lo apagas, solo funcionará en este equipo hasta que lo abras a mano.",
  "share.discovery": "Aparecer en el índice público",
  "share.discoveryHint": "Deja que las comunidades que marques como públicas se anuncien en Explorar, para que cualquiera pueda encontrarlas. Solo se anuncian el nombre, la descripción y la dirección; nunca los mensajes ni los archivos. Al apagarlo salen del índice en el acto.",
  "share.discoveryNeedsStable": "Con la dirección temporal de ahora no se publica nada: cambia en cada reinicio y el índice la rechaza. Sube al peldaño de dirección fija y se anunciará sola.",
  "share.closeLink": "Cerrar el enlace público",
  "share.opening": "Abriendo el túnel…",
  "share.needsCloudflared":
    "No se pudo preparar el motor del túnel automáticamente. Suele ser la conexión: comprueba internet y reintenta; la descarga se hace una sola vez.",
  "share.failed": "No se pudo abrir el túnel. Revisa tu conexión a internet.",
  "share.hostReminder":
    "Mientras este ordenador esté encendido, tu comunidad está en línea. Cuando lo apagues, deja de estarlo.",
  "share.quick": "Empezar ahora",
  "share.quickCost": "Gratis · dirección temporal",
  "share.stable": "Dirección fija",
  "share.stableCost": "Gratis · cuenta Tailscale",
  "share.alwaysOn": "Siempre activa",
  "share.alwaysOnCost": "Equipo propio o desde ~US$1,80/mes",
  "share.cloudflareHint": "Automático y sin cuenta. La dirección cambia al reiniciar, pero tus miembros pueden volver con la dirección nueva sin perder su perfil.",
  "share.fixedStep": "Paso {step} de 7 · Dirección fija",
  "share.tailscale.missing": "Instala Tailscale desde su página oficial. Requiere permiso de administrador porque añade un servicio de red.",
  "share.tailscale.login": "Inicia sesión en Tailscale y vuelve aquí; la detección se actualiza automáticamente.",
  "share.tailscale.ready": "Tailscale está conectado. El siguiente paso activa Funnel y fija esta dirección para siempre.",
  "share.tailscale.active": "Dirección fija activa. Se conserva al reiniciar y las invitaciones seguirán usando la misma URL.",
  "share.tailscale.error": "Falta completar un paso en Tailscale. Abre el enlace indicado y vuelve a intentarlo.",
  "share.tailscale.down": "Tu dirección fija está elegida pero Tailscale no la está publicando ahora mismo: nadie llega a tu servidor desde fuera. Pulsa «Continuar / reintentar» para volver a activarla.",
  "share.tutorial.install": "Instala Tailscale, crea tu cuenta e inicia sesión.",
  "share.tutorial.continue": "Pulsa «Continuar / reintentar» aquí; no busques Funnel en la consola.",
  "share.tutorial.authorize": "Si hace falta autorización, Distop abrirá directamente la página «Enable Funnel».",
  "share.tutorial.finish": "Aprueba Funnel, vuelve a Distop y pulsa «Continuar / reintentar» otra vez.",
  "share.authorizationRequired": "Falta una sola autorización",
  "share.authorizationHint": "La página ya está preparada para este equipo. Ábrela y acepta Enable Funnel; no tienes que editar políticas manualmente.",
  "share.enableFunnel": "Abrir y activar Funnel",
  "share.officialTutorial": "Ver tutorial oficial de Tailscale Funnel",
  "share.useCloudflare": "Desactivar dirección fija y usar Cloudflare",
  "share.continue": "Continuar / reintentar",
  "share.tailscaleFairUse": "Tailscale Funnel es gratis y estable, con límites de uso justo. El chat y la voz ligera funcionan bien; para muchos archivos grandes conviene Cloudflare con dominio propio.",
  "share.addressChanged": "La dirección pública cambió al reiniciar. Copia esta nueva dirección para tus miembros o activa Tailscale Funnel para fijarla.",
  "share.cloud": "Nube",
  "share.cloudTitle": "Siempre encendida (avanzado)",
  "share.cloudHint":
    "Una máquina que no se apaga nunca: una Raspberry en tu casa, un mini-PC o una VPS pequeña. Tu comunidad sigue en pie con tu ordenador apagado, y los datos siguen siendo tuyos — es la misma instancia, en otra máquina.",
  "share.cloudLimits":
    "No hay atajo gratis y encendido a la vez: o pones el hardware tú, o alquilas una máquina por unos euros al mes. La guía compara lo que hay hoy, con precios, y explica cómo publicarla sin pelearte con DNS ni certificados.",
  "share.cloudGuide": "Ver la guía, con precios",
  "share.alwaysOwnTitle": "Tengo una Raspberry o un equipo viejo",
  "share.alwaysOwnHint": "Sin cuota de alojamiento. Necesita estar encendido y una copia fuera del equipo.",
  "share.alwaysOwnAction": "Guía para Raspberry",
  "share.alwaysVpsTitle": "Ya tengo una VPS Ubuntu/Debian",
  "share.alwaysVpsHint": "El instalador verificable configura Docker, arranque automático y Tailscale Funnel.",
  "share.alwaysVpsAction": "Instalar paso a paso",
  "share.alwaysManagedTitle": "Quiero un botón y no administrar Linux",
  "share.alwaysManagedHint": "El catálogo administrado está pendiente de admisión. No se muestra un botón que todavía no puede completar el despliegue.",
  "share.cloudDeploy": "Desplegar",
  "share.cloudFixed": "Dirección fija configurada",
  "share.cloudFixedHint":
    "Esta instancia ya corre con dirección pública propia: viene de PUBLIC_URL en el entorno de la máquina. Para cambiarla, edita esa variable y reinicia el servidor.",
  "share.cloudTunnelsOff":
    "Con una dirección fija en la nube los túneles sobran: abrir uno aquí rompería la dirección que tus miembros ya usan.",

  "backups.title": "Copias de seguridad",
  "backups.scheduleOn": "Programadas: cada {hours} h, se conservan las {keep} más recientes.",
  "backups.scheduleOff": "La programación está apagada.",
  "backups.scheduleOffHint":
    "Se enciende con BACKUP_INTERVAL_HOURS y BACKUP_PASSPHRASE_FILE (y opcionalmente BACKUP_KEEP) en el entorno del servidor. Sin eso, ninguna copia se hace sola.",
  "backups.last": "Última copia: {date} · {size}",
  "backups.none": "Todavía no hay ninguna copia.",
  "backups.files": "Copias en el disco del servidor",
  "backups.manualUnavailable":
    "Las copias manuales solo se piden desde el propio equipo anfitrión. En una instancia en la nube, usa la programación por entorno.",
  "backups.create": "Crear copia ahora",
  "backups.passphrase": "Frase de la copia",
  "backups.passphraseHint":
    "Al menos 12 caracteres. Cifra la copia y no se guarda en ninguna parte: sin ella no se puede restaurar.",
  "backups.running": "Creando la copia…",
  "backups.done": "Copia creada.",
  "backups.failed": "La copia falló. Mira los registros del servidor.",
  "backups.guide": "Ver la guía de copias en la nube",

  "explore.title": "Explorar comunidades",
  "explore.open": "Explorar comunidades públicas",
  "explore.disabled": "El directorio de esta instancia está apagado",
  "explore.disabledHostHint":
    "Se enciende con PUBLIC_DISCOVERY_ENABLED=true en el entorno del servidor. Apagado es lo de fábrica: nada se anuncia sin que quien hospeda lo decida.",
  "explore.empty": "Ninguna comunidad se ha marcado como pública todavía",
  "explore.emptyHint":
    "Se marca en Administrar → General, con «Aparecer en el descubrimiento público».",
  "explore.needInvite":
    "Para entrar sigue haciendo falta una invitación de alguien de dentro: el directorio enseña, no abre puertas.",
  "explore.sourceInstance": "Esta instancia",
  "explore.sourceGlobal": "Directorio global",
  "explore.join": "Entrar",
  "notice.unread": "{count} sin leer",
  "notice.title": "Avisos",
  "notice.empty": "Nada que contarte todavía",
  "notice.emptyHint": "Aquí quedan los mensajes, las entradas a tus comunidades y lo que le pase a tu servidor mientras no estabas mirando.",
  "notice.go": "Ir",
  "notice.clear": "Vaciar",
  "notice.offlineTitle": "Se perdió la conexión",
  "notice.offlineBody": "No se llega a tu servidor. Lo que escribas ahora no saldrá hasta que vuelva.",
  "notice.onlineTitle": "Servidor de vuelta",
  "notice.onlineBody": "La conexión se ha restablecido.",
  "notice.memberTitle": "Alguien nuevo",
  "notice.memberBody": "{name} entró en {community}.",
  "explore.openMine": "Abrir",
  "explore.inviteOnly": "Con invitación",
  "explore.request": "Solicitar",
  "explore.requested": "Solicitud enviada. Quien administra la comunidad podrá aceptarla desde su panel.",
  "explore.identityMismatch": "La identidad de la instancia no coincide con la ficha publicada. No se enviaron credenciales.",
  "explore.unreachable": "No se pudo verificar la instancia en este momento.",

  "community.yours": "Tus comunidades",
  "community.create": "Crear comunidad",
  "community.createTitle": "Nueva comunidad",
  "community.name": "Nombre",
  "community.public": "Aparecer en el descubrimiento público",
  "community.publicHint": "Si lo dejas apagado solo se entra por invitación.",
  "community.visibility": "Quién puede encontrarla",
  "community.visibilityHint": "Esto controla su aparición; no concede acceso.",
  "community.visibility.private": "Privada · solo miembros",
  "community.visibility.unlisted": "No listada · quien tenga el enlace",
  "community.visibility.public": "Pública · aparece en Explorar",
  "community.joinPolicy": "Cómo se entra",
  "community.joinPolicyHint": "La visibilidad y el acceso son decisiones separadas.",
  "community.joinPolicy.open": "Entrada abierta",
  "community.joinPolicy.invite": "Solo con invitación",
  "community.joinPolicy.request": "Solicitar acceso",
  "community.publicStableHint": "Para aparecer en el Explorar global, la instancia necesita una dirección fija: Tailscale Funnel, un dominio propio o PUBLIC_URL. El túnel rápido de Cloudflare cambia al reiniciar y no se publica.",
  "community.publicIndexOff": "Esta instancia todavía no se anuncia en el índice público: enciéndelo en «Tu servidor» y la comunidad aparecerá en Explorar. Mientras tanto, marcarla como pública solo la hace visible aquí dentro.",
  "community.publicStableOk": "Tu dirección {host} es fija: al guardarla como pública, la comunidad aparece en el Explorar global en unos minutos.",
  "community.empty": "Aún no estás en ninguna comunidad",
  "community.emptyHint": "Crea la tuya o entra con un enlace de invitación.",
  "community.leave": "Salir de la comunidad",
  "community.leaveConfirm":
    "Perderás el acceso hasta que te vuelvan a invitar. ¿Salir?",
  "community.manage": "Ajustes de la comunidad",
  "community.invite": "Invitar gente",
  "community.join": "Entrar con un enlace",

  "discord.tab": "Importar de Discord",
  "discord.blankTab": "Desde cero",
  "discord.intro":
    "Trae un servidor de Discord con un bot creado por ti: canales, roles, historial y emojis entran en esta instancia. El token solo se usa en esta petición y no se guarda.",
  "discord.token": "Token del bot",
  "discord.guildId": "ID del servidor",
  "discord.guildIdHint": "En Discord: Ajustes → Avanzado → Modo desarrollador, y clic derecho sobre el servidor → Copiar ID.",
  "discord.preview": "Vista previa",
  "discord.previewCounts": "{channels} canales · {categories} categorías · {roles} roles · {emojis} emojis",
  "discord.previewMembers": "≈ {count} miembros",
  "discord.history": "Mensajes a traer por canal",
  "discord.historyNone": "Sin historial",
  "discord.members": "Importar la lista completa de miembros",
  "discord.membersHint": "Apagado, solo se archivan los autores del historial traído.",
  "discord.import": "Importar",
  "discord.importing": "Importando… con historial largo puede tardar varios minutos.",
  "discord.done": "Comunidad importada",
  "discord.reportSummary": "{channels} canales, {messages} mensajes y {profiles} perfiles archivados.",
  "discord.open": "Abrir la comunidad",
  "discord.warn.MESSAGE_CONTENT_EMPTY":
    "El historial llegó vacío: el bot necesita el intent «Message Content» activado en el portal de Discord.",
  "discord.warn.MEMBERS_ONLY_AUTHORS": "Solo se archivaron los autores del historial, no la lista completa de miembros.",
  "discord.warn.ATTACHMENTS_SKIPPED": "Algunos adjuntos no se pudieron descargar y quedaron fuera.",
  "discord.warn.UNSUPPORTED_CHANNELS": "Algunos canales son de tipos aún no admitidos y quedaron fuera.",
  "discord.warn.MEMBERS_TRUNCATED": "El servidor tiene más miembros de los que se pueden importar; la lista quedó recortada.",
  "invite.willUse": "El enlace saldrá con esta dirección:",
  "invite.check": "Comprobar que funciona",
  "invite.checking": "Comprobando…",
  "invite.reachable": "Responde. El enlace sirve para compartir.",
  "invite.unreachable": "No responde. Quien reciba el enlace no podrá entrar.",
  "invite.localOnly": "Es una dirección local: solo funciona en este equipo.",
  "invite.tunnelHere":
    "Se abre un enlace público y la invitación se rehace con él. No se guarda en ningún fichero: vive mientras el servidor esté encendido.",
  "invite.asSomeoneElse": "Entrar como otra persona",
  "invite.asSomeoneElseHint":
    "Cierra la sesión de {name} en este navegador y te deja entrar con otro nombre.",
  "settings.deleteAccount": "Eliminar mi cuenta",
  "settings.deleteAccountHint":
    "Borra tu cuenta de la base de datos: perfil, mensajes, archivos subidos y las comunidades de las que eres dueño, con todo lo que contienen. No hay copia ni papelera.",
  "settings.deleteConfirmLabel": "Escribe {username} para confirmar",
  "settings.deleteForever": "Eliminar para siempre",
  "invite.fixHint":
    "Abre un enlace público desde el panel «Tu servidor» y vuelve a crear la invitación.",
  "community.joinLabel": "Enlace o código de invitación",
  "community.joinHint":
    "Pega el enlace entero o solo el código: sirven los dos.",
  "community.joinAction": "Entrar",
  "community.unavailableTitle": "No se pudo abrir la comunidad",
  "community.unavailable":
    "El servidor no está encendido o ya no perteneces a esta comunidad. ¿Quieres intentar entrar con un enlace de invitación?",
  "community.rejoinHint": "Pega la dirección nueva del servidor o el enlace de invitación completo.",
  "community.forget": "Quitar de mi lista",
  "community.forgetConfirm": "Esto solo quita el acceso de este dispositivo. Tu membresía seguirá guardada en el servidor. ¿Continuar?",

  "channel.create": "Crear canal",
  "channel.name": "Nombre del canal",
  "channel.topic": "Tema",
  "channel.category": "Categoría",
  "channel.newCategory": "Nueva categoría",
  "channel.categoryName": "Nombre de la categoría",
  "channel.text": "Texto",
  "channel.voice": "Voz",
  "channel.announcement": "Anuncios",
  "channel.delete": "Eliminar canal",
  "channel.deleteConfirm":
    "Se borra el canal y todos sus mensajes. No hay vuelta atrás.",
  "channel.none": "Sin canales visibles",
  "channel.noneHint": "Pide acceso a la administración o crea uno.",
  "channel.voiceSoon":
    "Los canales de voz llegan en la fase 3. El canal ya existe y conserva sus permisos.",

  "channel.edit": "Editar canal",
  "channel.settings": "Ajustes de {name}",
  "channel.tabGeneral": "General",
  "channel.tabPermissions": "Permisos",
  "channel.nameInvalid": "Sin espacio al principio y sin # ni @.",
  "channel.topicHint": "Se ve en la cabecera del canal.",
  "channel.slowmode": "Modo lento",
  "channel.slowmodeHint":
    "Espera obligatoria entre un mensaje y el siguiente. Quien puede gestionar mensajes no la nota.",
  "channel.slowmodeOff": "Desactivado",
  "channel.permissionsHint":
    "Lo de aquí manda sobre lo que dice el rol, pero solo en este canal. Quitarle VIEW_CHANNEL a todo el mundo es lo que hace privado un canal.",
  "channel.allow": "Permitir",
  "channel.deny": "Denegar",
  "channel.inherit": "Heredar",
  "channel.markRead": "Marcar como leído",
  "channel.copyId": "Copiar ID del canal",
  "channel.duplicate": "Duplicar canal",
  "channel.moveUp": "Subir",
  "channel.moveDown": "Bajar",

  "category.settings": "Ajustes de {name}",
  "category.edit": "Editar categoría",
  "category.delete": "Eliminar categoría",
  "category.deleteConfirm":
    "Se borra la categoría, no sus canales: se quedan sueltos arriba de la lista.",
  "category.collapse": "Contraer",
  "category.expand": "Expandir",
  "category.markRead": "Marcar la categoría como leída",
  "category.addChannel": "Crear canal aquí",
  "category.copyId": "Copiar ID de la categoría",

  "message.placeholder": "Escribe en {channel}",
  "message.send": "Enviar",
  "message.empty": "Aquí no hay nada todavía",
  "message.emptyHint": "Sé quien rompe el hielo en {channel}.",
  "message.edited": "editado",
  "message.edit": "Editar",
  "message.delete": "Eliminar mensaje",
  "message.deleteConfirm": "¿Eliminar este mensaje?",
  "message.reply": "Responder",
  "message.replyingTo": "Respondiendo a {name}",
  "message.pin": "Fijar",
  "message.unpin": "Dejar de fijar",
  "message.pinned": "Mensajes fijados",
  "message.react": "Reaccionar",
  "message.loadMore": "Cargar mensajes anteriores",
  "message.attach": "Adjuntar archivo",
  "message.audioSend": "Enviar el audio",
  "message.audioRecord": "Grabar mensaje de audio",
  "message.audioRequesting": "Esperando permiso para usar el micrófono…",
  "message.audioRecording": "Grabando audio",
  "message.audioProcessing": "Preparando el audio…",
  "message.audioCancel": "Cancelar grabación",
  "message.audioStop": "Detener grabación",
  "message.audioUnsupported": "Este navegador no permite grabar mensajes de audio.",
  "message.audioSecure": "El micrófono solo funciona desde HTTPS o localhost.",
  "message.audioDenied": "No diste permiso al micrófono. Actívalo en el candado del navegador e inténtalo otra vez.",
  "message.audioNoMic": "No se encontró ningún micrófono.",
  "message.audioFailed": "No se pudo grabar el audio. Comprueba el micrófono e inténtalo otra vez.",
  "message.audioEmpty": "La grabación quedó vacía. Inténtalo otra vez.",
  "message.typingOne": "{name} está escribiendo…",
  "message.typingMany": "Varias personas están escribiendo…",
  "message.searchPlaceholder": "Buscar en este canal",
  "message.searchEmpty": "Sin resultados",
  "message.noPermission": "No puedes escribir en este canal.",
  "message.timedOut": "Estás silenciado temporalmente.",
  "message.tooLarge": "El archivo supera el límite del servidor ({mb} MB).",
  "message.mediaOff": "Quien administra la comunidad apagó este tipo de archivo.",
  "message.p2pSearching": "Buscando a quien lo tiene…",
  "message.p2pProgress": "Recibiendo {pct} %",
  "message.p2pOffline": "No disponible ahora: quien lo tiene no está conectado.",
  "message.p2pCorrupt": "Llegó dañado y se descartó.",
  "message.p2pRetry": "Reintentar",
  "message.p2pLoad": "Recibir directo",

  "voice.inChannel": "En canal de voz",
  "voice.invite": "Invitar a la llamada",
  "voice.connected": "Voz conectada",
  "voice.disconnect": "Colgar",
  "voice.soundboard": "Sonidos",
  "voice.soundboardEmpty":
    "Esta comunidad todavía no tiene sonidos. Se añaden en Ajustes de la comunidad → Emojis, stickers y sonidos.",
  "voice.soundboardMuted": "Activa el micrófono para poder usar los sonidos de la sala.",
  "voice.soundboardSearch": "Encuentra el sonido perfecto",
  "voice.soundboardNoResults": "No hay sonidos que coincidan con la búsqueda.",
  "voice.soundboardFrequent": "Usados frecuentemente",
  "voice.soundboardCommunity": "Sonidos de {name}",
  "voice.chatTitle": "Chat de voz",
  "voice.chatEmpty": "El chat de voz está vacío",
  "voice.chatEmptyHint": "Escribe algo sin salir de la llamada.",
  "voice.soundError.not_in_voice": "El servidor ya no te reconoce dentro de esta sala. Sal y vuelve a entrar.",
  "voice.soundError.muted": "No puedes lanzar sonidos mientras tienes el micrófono silenciado.",
  "voice.soundError.rate_limited": "Has lanzado demasiados sonidos seguidos. Espera unos segundos.",
  "voice.soundError.not_available": "Ese sonido ya no está disponible en esta comunidad.",
  "voice.soundError.unsupported": "Este navegador no puede reproducir los sonidos de la sala.",
  "voice.soundError.blocked": "El navegador bloqueó el audio. Interactúa con la página y vuelve a intentarlo.",
  "voice.soundError.download": "No se pudo descargar el sonido desde el servidor.",
  "voice.soundError.decode": "El archivo no contiene un audio que este navegador pueda reproducir.",
  "voice.soundError.too_long": "El sonido dura más de 30 segundos y no se puede usar como efecto.",
  "voice.mute": "Silenciar",
  "voice.unmute": "Hablar",
  "voice.deafen": "Ensordecer",
  "voice.undeafen": "Escuchar",
  "voice.join": "Entrar a la voz",
  "voice.meetingClosed": "Esta reunión todavía no está abierta o ya terminó.",
  "voice.forbidden": "La instancia no permitió entrar en esta sala.",
  "voice.full":
    "Esta sala está llena. Sin un servidor que reparta, cada voz se copia una vez por oyente, así que quien hospeda limita cuánta gente cabe a la vez en lugar de que se entrecorte para todos. Entra en cuanto salga alguien.",
  "voice.camera": "Cámara",
  "voice.cameraOff": "Apagar cámara",
  "voice.screen": "Pantalla",
  "voice.screenOff": "Dejar de compartir",
  "voice.screenSwitch": "Cambiar de ventana",
  "voice.videoFps": "Enviando a {fps} fps",
  "voice.fullscreen": "Pantalla completa",
  "voice.exitFullscreen": "Salir de pantalla completa",
  "voice.shareMute": "Silenciar sonido de la pantalla",
  "voice.shareUnmute": "Activar sonido de la pantalla",
  "voice.videoTitle": "Cámara y pantalla",
  "voice.videoIntro":
    "De tu cámara y tu pantalla, y solo para ti: nadie más nota lo que cambies aquí.",
  "voice.quality": "Resolución máxima del vídeo",
  "voice.qualityHint":
    "Es un techo, para tu cámara y para tu pantalla: si la fuente ya es más pequeña, no se amplía. No hay límite de pago, es tu propia subida y no afecta a nadie más.",
  "voice.qualityLow": "720p · hasta 30 fps · cámara 1,5 / pantalla 3 Mbit/s",
  "voice.qualityMedium": "1080p · hasta 60 fps · cámara 4 / pantalla 8 Mbit/s",
  "voice.qualityHigh": "1440p (2K) · hasta 120 fps · cámara 12 / pantalla 24 Mbit/s",
  "voice.priority": "Qué priorizar",
  "voice.priorityHint":
    "Cuando el ancho de banda no da para todo, algo se sacrifica. Aquí eliges qué: fotogramas o detalle.",
  "voice.priorityFluid": "Fluidez — movimiento suave, algo menos de nitidez",
  "voice.priorityBalanced": "Equilibrada — cámara fluida, pantalla nítida",
  "voice.prioritySharp": "Nitidez — imagen definida, la mitad de fotogramas",
  "voice.link.new": "conectando",
  "voice.link.connecting": "conectando",
  "voice.link.disconnected": "sin conexión",
  "voice.link.failed": "no conecta",
  "voice.link.closed": "desconectado",
  "voice.viaHost": "por el servidor",
  "voice.viaHostHint":
    "No hubo forma de conectar en directo con esta persona, así que su voz pasa por el servidor de la comunidad. Se oye igual: solo cambia el camino.",
  "voice.needsStun":
    "No se pudo descubrir vuestra dirección pública, así que el vídeo no llegará. La voz sigue funcionando.",
  "voice.needsTurn":
    "Vuestras redes no dejan conexión directa, así que el vídeo no llegará. La voz sigue funcionando: solo el vídeo necesita ese camino.",
  "voice.viaRelay":
    "El vídeo va por un relevo: no había ruta directa. Va cifrado de punta a punta.",
  "voice.videoDenied":
    "No diste permiso a la cámara, o cancelaste el diálogo de compartir pantalla.",
  "voice.videoUnsupported":
    "Este navegador no puede codificar vídeo por el servidor. Prueba el modo directo o un navegador Chromium actualizado.",
  "voice.noCamera":
    "No se encontró ninguna cámara. Conecta una y vuelve a intentarlo.",
  "voice.videoBackgroundFailed":
    "No se pudo preparar el fondo de cámara, así que la cámara no se encendió: enseñarte la habitación sin avisar sería lo contrario de lo que pediste. Quita el fondo en Ajustes → Cámara y pantalla para encenderla igualmente.",
  "voice.videoBackgroundUnsupported":
    "Este navegador no puede recortarte del fondo (le falta WebAssembly SIMD), y la cámara no se encendió para no enseñar el fondo real. Quita el fondo o usa un navegador más reciente.",
  "camBg.title": "Fondo de cámara",
  "camBg.intro":
    "Difumina tu habitación o cámbiala por otra cosa. El recorte se hace en tu equipo: la sala recibe la imagen ya compuesta y tu fondo real no sale de aquí.",
  "camBg.button": "Fondo",
  "camBg.blurTitle": "Difuminar",
  "camBg.none": "Sin fondo",
  "camBg.blurLight": "Difuminado suave",
  "camBg.blurStrong": "Difuminado fuerte",
  "camBg.presetsTitle": "Fondos incluidos",
  "camBg.preset.aurora": "Aurora",
  "camBg.preset.studio": "Estudio",
  "camBg.preset.dusk": "Atardecer",
  "camBg.preset.grove": "Arboleda",
  "camBg.customTitle": "Tus imágenes",
  "camBg.upload": "Subir imagen",
  "camBg.remove": "Quitar",
  "camBg.removeConfirm": "¿Quitar «{name}» de tus fondos? Se borra de este navegador.",
  "camBg.local":
    "Tus imágenes se guardan solo en este navegador: no se suben a la instancia ni las ve nadie más. Sin límite de pago, solo el espacio que tengas.",
  "camBg.cost":
    "El recorte corre en tu equipo y gasta CPU. En equipos justos puede bajar los fotogramas de la cámara; se quita cuando quieras.",
  "camBg.loading": "Preparando el recorte… la primera vez se descarga el motor (unos 12 MB) y luego queda guardado.",
  "camBg.willApply": "El fondo se aplicará en cuanto enciendas la cámara.",
  "camBg.unsupported":
    "Este navegador no puede recortarte del fondo: le falta WebAssembly SIMD. Prueba con una versión reciente de Chrome, Edge, Firefox o Safari.",
  "camBg.failed":
    "No se pudo preparar el fondo. La cámara no se ha encendido para no acabar enseñando la habitación que querías tapar.",
  "camBg.preview": "Probar con mi cámara",
  "camBg.previewStop": "Detener prueba",
  "camBg.previewHint": "Enciende la cámara un momento para ver cómo queda antes de entrar a una llamada.",
  "camBg.error.too_big": "La imagen pasa de 8 MB. Reduce su tamaño e inténtalo otra vez.",
  "camBg.error.not_image": "Ese archivo no es una imagen.",
  "camBg.error.too_many": "Ya tienes 12 fondos guardados. Quita alguno para añadir otro.",
  "camBg.error.no_storage": "Este navegador no dejó guardar la imagen. Puede estar en modo privado o sin espacio.",

  "voice.emptyRoom": "Sala de voz vacía",
  "voice.emptyRoomHint":
    "Entra tú primero: quien llegue después te oirá al instante.",
  "voice.fun": "Juegos de la sala",
  "voice.gravity": "Gravedad",

  "race.open": "Carrera",
  "race.join": "Unirse ({count})",
  "race.start": "Empezar",
  "race.leave": "Salir de la carrera",
  "race.host": "anfitrión",
  "race.lobbyTitle": "Esperando gente · {count} apuntados",
  "race.lobbyHostHint": "Abriste tú la carrera: elige mundo y da la salida cuando estén todos.",
  "race.lobbyGuestHint": "{name} da la salida cuando esté lista la sala.",
  "race.waiting": "La carrera empieza cuando lo diga quien la abrió.",
  "race.nextRound": "Te apuntaste con la carrera ya empezada: corres en la siguiente.",
  "race.title": "Carrera de canicas",
  "race.again": "Otra",
  "race.running": "Corriendo… gana quien cruce la meta primero.",
  "race.world.pegs": "Clavos",
  "race.world.ramps": "Rampas",
  "race.world.spinners": "Aspas",

  "voice.audioTitle": "Micrófono y sonido",
  "voice.audioIntro":
    "De este equipo y solo para ti: nadie más nota lo que cambies aquí.",
  "voice.inputDevice": "Dispositivo de entrada",
  "voice.outputDevice": "Salida de sonido",
  "voice.inputProfile": "Perfil de entrada",
  "voice.inputProfile.custom": "Personalizado",
  "voice.inputProfile.clear": "Voz clara",
  "voice.inputProfile.natural": "Sonido natural",
  "voice.inputVolume": "Volumen de entrada",
  "voice.outputVolume": "Volumen de salida",
  "voice.openInputMenu": "Abrir ajustes del micrófono",
  "voice.openOutputMenu": "Abrir ajustes de salida",
  "voice.openSettings": "Ajustes de voz",
  "voice.deviceUnnamed": "Micrófono {n}",
  "voice.deviceUnnamedOut": "Salida {n}",
  "voice.deviceNames":
    "Los nombres de los aparatos solo aparecen si das permiso al micrófono.",
  "voice.deviceAllow": "Ver los nombres",
  "voice.micVolume": "Volumen del micrófono",
  "voice.micVolumeHint":
    "Se aplica antes de enviar. Por encima del 100% se amplifica y puede saturar.",
  "voice.micTest": "Probar el micrófono",
  "voice.micTestStop": "Detener la prueba",
  "voice.micTestHint": "Habla: si la barra se mueve, se te oye. Nada sale de este equipo.",
  "voice.outVolume": "Volumen de la llamada",
  "voice.outVolumeHint": "Afecta a las voces y a los sonidos de la sala, no al resto del equipo.",
  "voice.outputFixed":
    "Este navegador no deja elegir por dónde suena: usa la salida del sistema.",
  "voice.noMedia":
    "El navegador solo da acceso al micrófono en https o en localhost. Entra por https para poder elegir aparato.",
  "voice.userVolume": "Volumen — {value}%",
  "voice.userVolumeHint": "Solo para ti. Nadie más lo nota.",
  "voice.denied":
    "No diste permiso al micrófono. Actívalo en el candado de la barra de direcciones y vuelve a entrar.",
  "voice.noDevice":
    "No se encontró ningún micrófono. Conecta uno y vuelve a intentarlo.",
  "voice.videoDirect": "El vídeo va directo entre navegadores.",
  "voice.unsupported":
    "Este navegador no sabe codificar voz. Prueba con Chrome, Edge o un navegador reciente.",
  "voice.relayTitle": "Cámara y pantalla compartida",
  "voice.relayIntro":
    "La voz y la imagen tienen cada una dos caminos, y quien hospeda elige. Por el servidor funciona siempre; en directo no consume nada de quien hospeda, pero necesita que las dos redes se dejen hablar.",
  "voice.voiceWay": "Por dónde va la voz",
  "voice.voiceHost": "Por el servidor",
  "voice.voiceHostHint":
    "Funciona siempre, sin configurar nada: si puedes abrir la aplicación, puedes hablar. Consume subida de quien hospeda, unos 4 KB por segundo y persona — poco, pero se multiplica por cada oyente.",
  "voice.voiceP2p": "Directa entre navegadores (recomendado)",
  "voice.voiceP2pHint":
    "La voz viaja de un aparato a otro y el servidor casi no gasta nada: es lo que permite hospedar en una máquina pequeña. Con quien no se consiga conexión directa, su voz vuelve sola por el servidor. Pasadas ocho o nueve personas en la sala, toda la llamada vuelve por el servidor.",
  "voice.videoWay": "Por dónde va la imagen",
  "voice.videoHost": "Por el servidor",
  "voice.videoHostHint":
    "Igual que la voz: funciona siempre, sin configurar nada. A cambio consume subida de quien hospeda, una copia por cada persona que mire. Para un grupo de amigos no se nota.",
  "voice.videoP2p": "Directa entre navegadores (recomendado)",
  "voice.videoP2pHint":
    "No consume nada a quien hospeda y da mejor calidad. Pero solo llega si las dos redes se dejan hablar, y muchas no: entre datos móviles y una casa casi nunca funciona.",
  "voice.probe": "Comprobar mi conexión",
  "voice.probeRunning": "Comprobando…",
  "voice.probeHint":
    "Tarda unos segundos. No llama a nadie ni enciende el micrófono.",
  "voice.probeLocal": "Red local",
  "voice.probeStun": "Dirección pública (STUN)",
  "voice.probeRelay": "Relevo (TURN)",
  "voice.probeRelayOk":
    "El relevo responde: la cámara y la pantalla llegarán aunque no haya ruta directa.",
  "voice.probeRelayDead":
    "El relevo configurado no contesta. Mientras siga así es como no tener ninguno: revisa la dirección y la contraseña.",
  "voice.probeDirectOnly":
    "Se descubre tu dirección pública, así que el vídeo irá bien en la mayoría de los casos. Fallará entre redes que no permitan conexión directa, típicamente datos móviles o una oficina. La voz no depende de esto.",
  "voice.probeNoStun":
    "No se pudo descubrir tu dirección pública: el vídeo solo llegará a gente de tu misma red local. La voz sigue funcionando con todo el mundo.",
  "voice.relayMet": "Relevo de Metered (sin tarjeta)",
  "voice.relayMetHint":
    "0,5 GB al mes sin dar ningún dato bancario, o 20 GB si añades tarjeta. Al agotarse deja de retransmitir: nunca te cobra de más. Solo entra cuando el vídeo no encuentra ruta directa.",
  "voice.relayMetStep1":
    "Crea una cuenta gratuita en metered.ca (no pide tarjeta).",
  "voice.relayMetStep2":
    "En el panel de TURN, copia el nombre de tu app y su API key.",
  "voice.relayMetStep3":
    "Pégalos aquí y guarda: se comprueba al momento y te dice si valen.",
  "voice.relayMetApp": "Nombre de la app",
  "voice.relayMetAppHint": "El subdominio de tu cuenta, sin «.metered.live».",
  "voice.relayMetKey": "API key",
  "voice.relayMetOpen": "Crear cuenta gratis en Metered",
  "voice.relayCfOpen": "Abrir el panel de Cloudflare",
  "voice.relayCustomOpen": "Crear cuenta gratis en ExpressTURN",
  "voice.relayCf": "Relevo de Cloudflare (1 TB al mes, pide tarjeta)",
  "voice.relayCfHint":
    "Solo entra cuando no hay ruta directa, así que casi nunca gasta. Ve paquetes cifrados y vuestras IP; no puede ver ni oír el contenido. Tu clave se queda en el servidor y nunca llega al navegador.",
  "voice.relayCfStep1":
    "Entra en el panel de Cloudflare → Realtime → TURN y crea una clave (Create TURN key).",
  "voice.relayCfStep2":
    "Copia el identificador de la clave (TURN Key ID) y su token (API token).",
  "voice.relayCfStep3":
    "Pégalos aquí y guarda: se comprueba al momento y te dice si valen.",
  "voice.relayCfKey": "Identificador de la clave",
  "voice.relayCfKeyHint": "El TURN Key ID que te dio Cloudflare.",
  "voice.relayCfToken": "Token de la clave",
  "voice.relayCfSave": "Guardar y comprobar",
  "voice.relayDirect": "Solo conexión directa",
  "voice.relayDirectHint":
    "El vídeo no sale de vuestros aparatos por ningún intermediario. A cambio, entre redes que no permitan conexión directa no se verá nada. Hablar se sigue pudiendo siempre.",
  "voice.relayCustom": "Usar un servidor TURN",
  "voice.relayCustomHint":
    "Reenvía el vídeo cuando no hay ruta directa. Ve paquetes cifrados y vuestras IP; no puede ver ni oír el contenido.",
  "voice.relayCustomStatic": "Usuario y contraseña fijos",
  "voice.relayCustomStaticHint":
    "Para TURN con credencial estática: ExpressTURN, un coturn con usuario fijo o similar.",
  "voice.relayEphemeral": "Secreto compartido (use-auth-secret)",
  "voice.relayEphemeralHint":
    "Para un coturn propio con use-auth-secret: la instancia acuña usuarios temporales con ese secreto, caducan solos y rotan sin tocar nada.",
  "voice.relaySecret": "Secreto compartido",
  "voice.relaySecretHint":
    "Al menos 16 caracteres, el mismo static-auth-secret de turnserver.conf. Se guarda en el servidor y no vuelve a mostrarse.",
  "voice.relayEphemeralActive": "Credenciales rotando automáticamente.",
  "voice.relayEphemeralOpen": "Ver la guía de coturn en la nube",
  "voice.relayHelp":
    "Para cualquier TURN con usuario y contraseña fijos: coturn propio, ExpressTURN (turn:relay1.expressturn.com:3478, gratis, responde en los puertos 3478, 80 y 443) o similar. Al guardar se comprueba que relevé de verdad.",
  "voice.relayUrl": "Dirección del TURN",
  "voice.relayUser": "Usuario",
  "voice.relayPassword": "Contraseña",
  "voice.relayPasswordHint":
    "Se guarda en el servidor y no vuelve a mostrarse.",
  "voice.relaySaved": "Guardado. Se aplica en las próximas llamadas.",
  "voice.relayLocked":
    "Fijado desde el entorno del servidor (ICE_SERVERS, o TURN_URL y TURN_SECRET). Quita esas variables para cambiarlo aquí.",
  "voice.relayHostOnly": "Solo quien hospeda puede cambiar esto.",
  "voice.device": "Micrófono",
  "voice.deviceDefault": "El del sistema",
  "voice.limits":
    "La voz va directa entre navegadores. Si un par no conecta, solo esa voz vuelve por el servidor; con una sala grande, toda la voz vuelve al servidor automáticamente.",

  "members.title": "Miembros",
  "members.online": "En línea",
  "members.offline": "Desconectados",
  "members.owner": "Propietaria",
  "members.guest": "Invitado",
  "members.kick": "Expulsar",
  "members.ban": "Bloquear",
  "members.unban": "Desbloquear",
  "members.timeout": "Silenciar 10 minutos",
  "members.untimeout": "Quitar silencio",
  "members.roles": "Roles",
  "members.joined": "Entró el {date}",
  "members.note": "Nota (solo la ves tú)",
  "members.notePlaceholder":
    "Para acordarte de quién es. No sale de tu cuenta.",
  "members.mutual": "Comunidades en común",
  "members.banned": "Bloqueado",
  "members.inVoice": "En una sala de voz",
  "members.created": "Cuenta creada el {date}",
  "members.disconnected": "Sin conexión",

  "settings.title": "Ajustes",
  "settings.profile": "Perfil",
  "settings.appearance": "Apariencia",
  "settings.voice": "Voz y vídeo",
  "settings.account": "Cuenta",
  "settings.displayName": "Nombre visible",
  "settings.bio": "Sobre ti",
  "settings.pronouns": "Pronombres",
  "settings.accent": "Color de acento",
  "settings.gameActivity": "Actividad de juego",
  "settings.gameActivityHint":
    "La detección corre en la aplicación de escritorio, en tu equipo. Al servidor solo llega el nombre del juego, nunca tu lista de programas.",
  "settings.gameShare": "Mostrar a qué estoy jugando",
  "settings.gameShareHint": "Apagado, nadie ve tu partida en curso y la detección deja de enviarse.",
  "settings.gameHistory": "Mostrar mis juegos recientes en el perfil",
  "settings.gameHistoryHint": "Apagado, tu historial de partidas queda solo para ti.",
  "settings.gameCheck": "Comprobar la detección",
  "settings.gameOnlyDesktop":
    "La detección solo funciona en la aplicación de escritorio, y de momento solo en Windows: un navegador no puede ver qué programas tienes abiertos.",
  "settings.gameFound": "Detectado ahora mismo: {name}.",
  "settings.gameNotScanned": "Todavía no ha habido ninguna pasada. Espera unos segundos y vuelve a probar.",
  "settings.gameNoTasklist":
    "Windows no dejó consultar los programas abiertos, así que solo se reconocen los juegos de Steam.",
  "settings.gameNothing":
    "Ninguno de los {processes} programas abiertos es un juego conocido, y Steam no tiene ninguna partida en marcha. Se reconocen solos los juegos de Steam y de Epic; para cualquier otro, añade su ejecutable a games.json ({catalog} reconocidos ahora).",
  "settings.desktopApp": "Aplicación",
  "settings.desktopApps": "Aplicaciones integradas",
  "settings.desktopAppsHint":
    "Apagada, su pestaña desaparece y su memoria se libera. Tu sesión no se cierra: al reactivarla entras sin volver a vincular.",
  "settings.desktopWhatsapp": "WhatsApp",
  "settings.desktopTelegram": "Telegram",
  "settings.gameWatch": "Detección de juegos en este equipo",
  "settings.gameWatchHint":
    "Apagada, la aplicación deja de mirar los procesos de este equipo por completo, no solo el reporte.",
  "settings.gameWatchToggle": "Detectar juegos",
  "settings.avatar": "Tu avatar",
  "settings.avatarHint":
    "Sube un PNG, JPG, GIF o WebP, o pega un enlace. Los GIF animados valen igual: aquí no se cobra por eso.",
  "settings.galleryAvatar": "Elegir de la galería",
  "settings.galleryBanner": "Elegir de la galería de perfiles",
  "settings.galleryCategory": "Categoría",
  "settings.galleryAnimated":
    "Las marcadas con ✦ son animadas. Aquí no cuestan nada.",
  "settings.galleryError":
    "La galería no respondió. Prueba otra vez en un momento.",
  "settings.bannerHint": "La imagen ancha de tu perfil. Animada también vale.",
  "settings.banner": "Tu banner",
  "settings.bannerTune": "Ajustar el banner",
  "settings.bannerTuneHint": "Mueve el punto de enfoque para elegir qué parte de la imagen se ve.",
  "settings.bannerPreview": "Vista previa del encuadre del banner",
  "settings.bannerPositionX": "Posición horizontal",
  "settings.bannerPositionY": "Posición vertical",
  "settings.theme": "Tema",
  "settings.themeLight": "Claro",
  "settings.themeDark": "Oscuro",
  "settings.themeSystem": "Del sistema",
  "settings.accentUi": "Color de acento",
  "settings.accentCustom": "Elegir otro color",
  "settings.reset": "Restablecer",
  "settings.corners": "Esquinas",
  "settings.font": "Tipografía",
  "settings.fontDefault": "La de la casa",
  "settings.fontSystem": "Del sistema",
  "settings.fontSerif": "Con remates",
  "settings.fontMono": "Monoespaciada",
  "settings.backdrop": "Fondo de la conversación",
  "settings.backdropPlain": "Liso",
  "settings.backdropSoft": "Degradado",
  "settings.backdropDots": "Puntos",
  "settings.wallpaper": "Fondo de pantalla",
  "settings.wallpaperSearch": "Buscar un fondo",
  "settings.wallpaperHide": "Cerrar el buscador",
  "settings.wallpaperClear": "Quitar el fondo",
  "settings.wallpaperPlaceholder": "mountains, abstract, city at night…",
  "settings.wallpaperEmpty":
    "Nada con esa búsqueda. Wallhaven etiqueta en inglés: prueba «mountains» en vez de «montañas».",
  "settings.wallpaperError": "No se pudo buscar. Wallhaven no respondió.",
  "settings.wallpaperOwn": "Tu propia imagen",
  "settings.wallpaperOwnHint":
    "Sube un fichero o pega una URL. Se guarda en el disco de quien hospeda.",
  "settings.wallpaperTune": "Ajustar el fondo",
  "settings.wallpaperVeil": "Velo",
  "settings.wallpaperBlur": "Desenfoque",
  "settings.wallpaperBright": "Brillo",
  "settings.wallpaperContrast": "Contraste",
  "settings.wallpaperSaturate": "Color",
  "settings.motion": "Animaciones",
  "settings.motionHint":
    "Apágalas si prefieres una interfaz completamente quieta.",
  "settings.fontSize": "Tamaño de texto",
  "settings.density": "Densidad",
  "settings.densityCompact": "Compacta",
  "settings.densityCozy": "Cómoda",
  "settings.language": "Idioma",
  "settings.logout": "Cerrar sesión",
  "settings.upgrade": "Convertir en cuenta permanente",
  "settings.upgradeHint":
    "Conservas tus mensajes, comunidades y tu identidad. Solo añades usuario y contraseña.",
  "settings.revokeAll": "Cerrar sesión en todos los dispositivos",
  "settings.changePassword": "Cambiar la contraseña",
  "settings.changePasswordHint":
    "Al cambiarla se cierran las sesiones de los demás dispositivos. Esta sigue abierta.",
  "settings.currentPassword": "Contraseña actual",
  "settings.newPassword": "Contraseña nueva",
  "settings.passwordChanged": "Contraseña cambiada. Las demás sesiones quedaron cerradas.",

  "manage.title": "Administrar {name}",
  "manage.overview": "General",
  "manage.roles": "Roles",
  "manage.invites": "Invitaciones",
  "manage.audit": "Auditoría",
  "manage.data": "Datos",
  "manage.description": "Descripción",
  "manage.requests": "Solicitudes",
  "manage.requestsEmpty": "No hay solicitudes pendientes",
  "manage.requestsEmptyHint": "Cuando alguien solicite acceso desde Explorar aparecerá aquí.",
  "manage.approve": "Aceptar",
  "manage.reject": "Rechazar",
  "manage.rules": "Reglas",
  "manage.icon": "URL del ícono",
  "manage.iconHint":
    "Es lo que se ve en la barra lateral. Cuadrada queda mejor.",
  "manage.banner": "URL del banner",
  "manage.accent": "Color de la comunidad",
  "manage.newRole": "Nuevo rol",
  "manage.roleName": "Nombre del rol",
  "manage.permissions": "Permisos",
  "manage.roleDelete": "Eliminar rol",
  "manage.defaultRole": "Rol base: lo tiene todo el mundo al entrar.",
  "manage.newInvite": "Crear invitación",
  "manage.inviteUses": "Usos",
  "manage.inviteExpires": "Caduca",
  "manage.inviteNever": "Nunca",
  "manage.inviteUnlimited": "Sin límite",
  "manage.export": "Exportar comunidad",
  "manage.exportHint":
    "Descarga un JSON con canales, mensajes, roles y miembros. Es tuyo: sirve para migrar a otro servidor o guardarlo como copia.",
  "manage.dangerZone": "Zona sensible",
  "manage.deleteCommunity": "Eliminar comunidad",
  "manage.deleteConfirm":
    "Escribe {name} para confirmar. Se borra todo: canales, mensajes y archivos.",
  "manage.auditEmpty": "Sin actividad registrada todavía.",

  "invite.joining": "Te invitaron a",
  "invite.memberOne": "{count} miembro",
  "invite.members": "{count} miembros",
  "invite.onlineNow": "{count} en línea",
  "invite.accept": "Entrar a la comunidad",
  "invite.asGuest": "Entrar como invitado",
  "invite.guestName": "¿Cómo quieres que te llamen?",
  "invite.invalid": "Esta invitación no existe, caducó o agotó sus usos.",
  "invite.back": "Ir a mis comunidades",

  "error.generic": "Algo falló en el servidor.",
  "error.network":
    "No se pudo hablar con el servidor. Comprueba que esté encendido.",
  "error.unreachable":
    "El servidor no respondió (HTTP {status}). Suele significar que está apagado o que el túnel se cayó.",
  "skip.toMessages": "Saltar a los mensajes",

  "unread.some": "Mensajes sin leer",
  "unread.mentions": "{count} menciones sin leer",
  "unread.newMessages": "Mensajes nuevos",
  "unread.jump": "Ir a lo último",
  "unread.jumpCount": "{count} sin leer",

  "message.dropHere": "Suelta los archivos para adjuntarlos",
  "message.mentionUser": "Mencionar a alguien",
  "message.mentionChannel": "Enlazar un canal",
  "message.imageOpen": "Ver imagen completa",

  "settings.notifications": "Avisos",
  "settings.notifyAll": "Todos los mensajes",
  "settings.notifyMentions": "Solo cuando me nombran",
  "settings.notifyOff": "Ninguno",
  "settings.notifyHint":
    "Vale para todas las comunidades de este servidor. Nada de esto sale del dispositivo.",
  "settings.sounds": "Sonidos de la aplicación",
  "settings.soundsHint":
    "Notificaciones e interruptores usan el pack SND01 adaptado para Distop.",
  "settings.desktopNotifications": "Notificaciones del sistema",
  "settings.desktopHint": "Solo aparecen con la ventana en segundo plano.",
  "settings.availabilityWatch": "Avisarme cuando esta comunidad vuelva",
  "settings.availabilityWatchHint": "Distop la comprueba desde la bandeja. Tras 15 minutos sin respuesta, reduce la frecuencia para ahorrar batería.",
  "meeting.section": "Reuniones",
  "meeting.history": "Historial",
  "meeting.historyHint": "Las reuniones terminadas o canceladas se guardan aquí. La barra lateral solo enseña la que está pasando ahora mismo.",
  "meeting.historyEmpty": "No hay reuniones terminadas todavía.",
  "meeting.deleteConfirm": "¿Eliminar «{name}»? Se borra el canal con sus mensajes. No se puede deshacer.",
  "voice.pin": "Fijar en grande",
  "voice.unpin": "Dejar de fijar",
  "voice.layout": "Cómo se ve",
  "voice.layoutGallery": "Todos igual",
  "voice.layoutSpeaker": "Quien habla, grande",
  "voice.layoutPresentation": "Lo compartido, grande",
  "meeting.guestLeave": "Salir",
  "meeting.create": "Convocar reunión",
  "meeting.title": "Título",
  "meeting.agenda": "Orden del día",
  "meeting.agendaHint": "Opcional. Lo verá todo el mundo antes de entrar.",
  "meeting.when": "Cuándo",
  "meeting.whenHint": "Opcional. Sin fecha, la reunión queda en borrador hasta que la abras.",
  "meeting.lobbyOption": "Sala de espera: nadie entra hasta que le abras",
  "meeting.loadFailed": "No se pudo cargar esta reunión.",
  "meeting.yourRole": "Tu papel",
  "meeting.overHint": "Esta reunión terminó. El chat y los archivos siguen aquí.",
  "meeting.state.draft": "Borrador",
  "meeting.state.scheduled": "Convocada",
  "meeting.state.lobby": "Puertas abiertas",
  "meeting.state.live": "En curso",
  "meeting.state.ended": "Terminada",
  "meeting.state.cancelled": "Cancelada",
  "meeting.startToJoin": "Inicia la reunión para entrar",
  "meeting.role.host": "Organiza",
  "meeting.role.cohost": "Coorganiza",
  "meeting.role.presenter": "Presenta",
  "meeting.role.attendee": "Asiste",
  "meeting.role.viewer": "Solo mira",
  "meeting.waitingHint": "Estás en la sala de espera. Quien organiza tiene que dejarte pasar.",
  "meeting.recordingBeforeEntry": "Esta reunión ya se está grabando. Entrar es decisión tuya.",
  "meeting.lobbyTitle": "Esperando fuera",
  "meeting.lobbyEmpty": "No hay nadie esperando.",
  "meeting.admit": "Dejar entrar",
  "meeting.deny": "No dejar entrar",
  "meeting.admitAll": "Dejar entrar a todos",
  "meeting.handsTitle": "Piden la palabra",
  "meeting.handsEmpty": "Nadie ha levantado la mano.",
  "meeting.handRaise": "Levantar la mano",
  "meeting.handLower": "Bajar la mano",
  "meeting.floorTitle": "Turno de palabra",
  "meeting.floorFree": "Ahora mismo no habla nadie.",
  "meeting.floorMine": "Tienes la palabra.",
  "meeting.floorTaken": "Tiene la palabra {name}.",
  "meeting.floorHold": "Mantén pulsado para hablar",
  "meeting.floorRelease": "Suelta para callar",
  "meeting.floorViewer": "Con tu papel actual no puedes hablar en esta reunión.",
  "meeting.floorJoinFirst": "Entra en la reunión para pedir la palabra.",
  "meeting.someone": "alguien",
  "meeting.recordingAboutTo": "{name} va a empezar a grabar.",
  "meeting.recordingNow": "{name} está grabando esta reunión.",
  "meeting.recordStart": "Grabar",
  "meeting.recordStop": "Parar",
  "meeting.recordNeedsCall": "Entra a la reunión para poder grabarla: se graba lo que se oye y la pantalla que elijas.",
  "meeting.budgetHost": "La conexión de quien hospeda no da para todas las cámaras: {queued} en espera, {slots} a la vez. La pantalla compartida tiene prioridad.",
  "meeting.budgetDirect": "Hay {queued} cámaras en espera. En modo directo el reparto lo aplica cada equipo.",
  "meeting.openLobby": "Abrir puertas",
  "meeting.start": "Empezar",
  "meeting.end": "Terminar",
  "meeting.endConfirm": "Terminar la reunión. No se puede volver a abrir: la asistencia y la duración quedan como están.",
  "meeting.settings": "Ajustes de la reunión",
  "meeting.roles": "Papeles",
  "meeting.rolesHint": "Los papeles valen solo dentro de esta reunión. No cambian nada en la comunidad.",
  "meeting.roleOf": "Papel de {name}",
  "meeting.invites": "Invitaciones",
  "meeting.invitesHint": "Un enlace para entrar sin cuenta, solo a esta reunión. El enlace se enseña una única vez.",
  "meeting.invitesEmpty": "Todavía no has creado ninguna.",
  "meeting.inviteLabel": "Para acordarte de a quién es",
  "meeting.inviteCreate": "Crear enlace",
  "meeting.inviteOnce": "Cópialo ahora: no se puede volver a ver.",
  "meeting.inviteUnnamed": "Sin nombre",
  "meeting.inviteUses": "{used} usos",
  "meeting.inviteRevoke": "Anular",
  "meeting.inviteRevoked": "Anulado",
  "meeting.attendance": "Quién estuvo",
  "meeting.attendanceEmpty": "Todavía no ha entrado nadie.",
  "meeting.minutes": "{n} min",
  "meeting.hoursMinutes": "{h} h {m} min",
  "meeting.calendar": "Mi agenda en el calendario",
  "meeting.calendarHint": "Una dirección para suscribir tu calendario. Trae solo tus reuniones, no da acceso a nada más, y puedes anularla cuando quieras.",
  "meeting.calendarCreate": "Crear dirección",
  "meeting.calendarOnce": "Cópiala ahora: no se puede volver a ver. Pégala en tu calendario como «suscribirse a un calendario por URL».",
  "meeting.calendarEmpty": "No tienes ninguna dirección creada.",
  "meeting.calendarNever": "Sin usar",
  "meeting.calendarUsed": "Última vez: {when}",
  "meeting.guestTitle": "Te invitaron a una reunión",
  "meeting.guestName": "¿Cómo quieres que te llamen?",
  "meeting.guestEnter": "Entrar",
  "meeting.guestInvalid": "Este enlace de reunión ya no vale.",
  "meeting.guestScoped": "Este enlace vale solo para esta reunión. No te crea una cuenta ni te mete en la comunidad.",
  "settings.push": "Avisarme aunque tenga Distop cerrado",
  "settings.pushHint": "El navegador enseña el aviso aunque no haya ninguna pestaña abierta. Lo manda tu propia instancia, sin intermediarios de pago.",
  "settings.pushPrivacy": "El aviso va cifrado y no lleva nombres ni mensajes, solo de qué tipo es. Aun así, el servicio de notificaciones de tu navegador sabe cuándo y cada cuánto te llega uno.",
  "settings.pushUnsupported": "Este navegador no admite avisos en segundo plano.",
  "settings.pushUnavailable": "Esta instancia todavía no tiene una dirección pública por la que puedan llegarte.",
  "settings.pushDenied": "El navegador bloqueó las notificaciones. Se cambia en los permisos del sitio.",
  "settings.pushFailed": "No se pudo activar. Inténtalo otra vez.",
  "settings.notifyAsk": "Permitir notificaciones",
  "settings.notifyGranted": "Permitidas por el navegador.",
  "settings.notifyDenied":
    "El navegador las tiene bloqueadas para este sitio. Se cambia desde el candado de la barra de direcciones.",
  "settings.notifyUnsupported": "Este navegador no las admite.",

  "voice.person": "Opciones de esta persona",
  "voice.forceMute": "Silenciar",
  "voice.forceUnmute": "Devolver la palabra",
  "voice.forceDeafen": "Ensordecer",
  "voice.forceUndeafen": "Quitar el ensordecido",
  "voice.forceDisconnect": "Sacar de la llamada",
  "voice.forcedMuted": "Silenciado por moderación",
  "voice.cannotSpeak": "No puedes hablar en esta sala",
  "voice.forcedDeafened": "Ensordecido por moderación",
  "picker.emojis": "Emojis",
  "picker.stickers": "Stickers",
  "picker.recent": "Usados hace poco",
  "picker.popular": "Los de siempre",
  "picker.results": "Resultados",
  "picker.group.all": "Todos",
  "picker.group.smileys": "Caras y emociones",
  "picker.group.people": "Personas y cuerpo",
  "picker.group.nature": "Animales y naturaleza",
  "picker.group.food": "Comida y bebida",
  "picker.group.travel": "Viajes y lugares",
  "picker.group.activities": "Actividades",
  "picker.group.objects": "Objetos",
  "picker.group.symbols": "Símbolos",
  "picker.group.flags": "Banderas",
  "picker.flagsUnsupported":
    "Tu sistema no dibuja banderas y aquí salen como letras. Se envían igual: quien las reciba en un móvil o un Mac las verá bien.",
  "picker.animatedCredit": "Nombres: CLDR de Unicode. Animaciones al enviar: Noto Emoji de Google (CC BY 4.0).",
  "picker.search": "Busca un emoji",
  "picker.searchGif": "Busca un GIF",
  "picker.searchSticker": "Busca un sticker",
  "picker.gallery": "Galería",
  "picker.empty": "Nada por aquí.",
  "picker.noStickers":
    "Esta comunidad todavía no tiene stickers. Cualquiera con permiso puede subirlos.",
  "picker.addPack": "A\u00f1adir mi paquete de stickers",
  "picker.addPackFormat":
    "PNG, WebP o GIF, con fondo transparente. SVG no se admite. Se ven mejor cuadrados, alrededor de 320\u00d7320 px. El nombre lleva letras, n\u00fameros y guion bajo, de 2 a 32 caracteres: es el que escribir\u00e1s en el chat. No hay n\u00famero m\u00e1ximo de stickers \u2014 el techo es el disco de quien hospeda.",
  "picker.addPackGo": "Subirlos ahora",
  "picker.addPackNoPermission":
    "Los sube quien tenga permiso para gestionar la comunidad.",
  "picker.gifError": "El buscador de GIF no respondió.",
  "picker.open": "Emojis, stickers y GIF",

  "emoji.title": "Emojis, stickers y sonidos",
  "emoji.hint":
    "Se guardan en el disco de quien hospeda. No hay un número máximo.",
  "emoji.add": "Añadir",
  "emoji.name": "Nombre",
  "emoji.nameHint":
    "Letras, números y guion bajo. Así se escribirá entre dos puntos.",
  "emoji.nameHintSound": "Letras, números y guion bajo. Es como aparecerá en la lista de sonidos.",
  "emoji.kind": "Tipo",
  "emoji.kindEmoji": "Emoji",
  "emoji.kindSticker": "Sticker",
  "emoji.kindSound": "Sonido",
  "emoji.soundFile": "Archivo de audio",
  "emoji.soundIcon": "Foto o emoji del sonido",
  "emoji.soundIconHint": "Opcional. Escribe un emoji o sube una imagen; se mostrará en el botón del sonido.",
  "emoji.soundIconEmoji": "Emoji",
  "emoji.soundIconImage": "Subir imagen",
  "emoji.image": "Imagen",
  "emoji.none": "Todavía no hay ninguno.",
  "emoji.deleteConfirm":
    "¿Quitar esto de la comunidad? Los mensajes que lo usaban mostrarán su nombre.",
  "profile.identity": "Identidad",
  "profile.avatarDeco": "Avatar y decoración",
  "profile.bannerPlate": "Banner y placa",
  "profile.nameStyle": "Estilo del nombre",
  "profile.theme": "Tema del perfil",
  "profile.memberSince": "Miembro desde",
  "profileStyle.deco": "Decoración del avatar",
  "profileStyle.ringsCredit":
    "Aros: Original Lab — SillyTavern Avatar Decorations Community Project (CC BY 4.0).",
  "profileStyle.ownDeco": "Tu propia decoración",
  "profileStyle.ownDecoHint":
    "Un PNG con el centro transparente. Se dibuja alrededor del avatar. Sube el que quieras: no hay lista cerrada.",
  "profileStyle.font": "Fuente del nombre",
  "profileStyle.effect": "Efecto del nombre",
  "profileStyle.profileEffect": "Efecto de la tarjeta",
  "profileStyle.nameColor": "Color del nombre",
  "profileStyle.themeA": "Tema 1",
  "profileStyle.themeB": "Tema 2",
  "profileStyle.gradient": "Gradiente de la tarjeta",
  "profileStyle.gradientHint": "Ajusta los dos colores, su dirección y dónde se equilibran. También se aplica al cuerpo del perfil.",
  "profileStyle.gradientPreview": "Vista previa del gradiente",
  "profileStyle.gradientAngle": "Dirección",
  "profileStyle.gradientBalance": "Punto de mezcla",
  "style.none": "Ninguno",
  "style.neon": "Neón",
  "style.ember": "Brasa",
  "style.mist": "Neblina",
  "style.aurora": "Aurora",
  "style.sunset": "Atardecer",
  "style.forest": "Bosque",
  "style.ocean": "Océano",
  "style.default": "Normal",
  "style.display": "Titular",
  "style.mono": "Monoespaciada",
  "style.serif": "Serif",
  "style.round": "Redondeada",
  "style.wide": "Espaciada",
  "style.pixel": "Píxel retro",
  "style.arcade": "Arcade",
  "style.plain": "Liso",
  "style.gradient": "Degradado",
  "style.pop": "Pop",
  "style.animated": "Animado",
  "style.breathe": "Respiración",
  "style.embers": "Brasas",
  "style.snow": "Nieve",
  "style.fireworks": "Fuegos artificiales",
  "style.bubbles": "Burbujas",
  "emoji.telegramImport": "Importar de un paquete de Telegram",
  "emoji.telegramHint":
    "Escribe el nombre del paquete (el de la URL t.me/addstickers/nombre). Solo estáticos por ahora.",
  "emoji.telegramPlaceholder": "NombreDelPaquete",
  "emoji.telegramSearch": "Buscar",
  "emoji.telegramEmpty": "Ese paquete no tiene stickers, o no existe.",
  "emoji.telegramAnimatedYet": "Animado: todavía no se puede importar.",
  "emoji.telegramAdd": "Importar",

  "emoji.soundGallery": "Descargar desde MyInstants",
  "emoji.soundGalleryHint":
    "Busca el sonido en MyInstants, descárgalo y súbelo arriba eligiendo «Sonido». Lo suben usuarios y no está filtrado: revisa que puedas usarlo.",
  "emoji.soundOpen": "Abrir MyInstants",

  "status.online": "En línea",
  "status.offline": "Desconectado",
  "status.idle": "Ausente",
  "status.dnd": "No molestar",
  "status.invisible": "Invisible",
  "status.invisibleHint":
    "Sigues dentro, pero para los demás apareces desconectado.",
  "status.dndHint": "No suenan los avisos.",
  "status.custom": "Estado personalizado",
  "status.customPlaceholder": "¿Qué estás haciendo?",
  "status.clear": "Quitar el estado",
  "status.change": "Cambiar de estado",
  "status.label": "Estatus",
  "status.back": "Volver al perfil",

  "profile.edit": "Editar perfil",
  "profile.copyUser": "Copiar nombre de usuario",

"common.saving": "Guardando…",

  "community.mediaImages": "Fotos",
  "community.mediaImagesHint": "Deja adjuntar imágenes en los canales. Apágalo si tu servidor es una VPS pequeña: cada foto ocupa disco y tráfico.",
  "community.mediaVideos": "Vídeos",
  "community.mediaVideosHint": "Deja adjuntar vídeos. Son lo que más gasta: en una VPS conviene tenerlos apagados.",
  "community.mediaFiles": "Otros archivos",
  "community.mediaFilesHint": "Deja adjuntar documentos y cualquier otro archivo que no sea foto, vídeo ni audio.",
  "community.mediaModeServer": "Servidor — queda disponible aunque quien lo envió se desconecte",
  "community.mediaModeP2p": "P2P — no ocupa disco de la instancia",
  "community.mediaModeOff": "Apagado",
  "community.voiceMessages": "Mensajes de voz",
  "community.voiceMessagesHint":
    "Deja que la gente grabe audio y lo mande en los canales. Ocupa sitio en tu servidor y hay que moderarlo como cualquier otro archivo.",

  "message.audioPlay": "Reproducir",
  "message.audioPause": "Pausar",
  "message.audioSeek": "Ir a un punto del audio",

  "voice.cameraDevice": "Cámara",
  "voice.cameraHint": "La que se enciende al activar el vídeo en una llamada.",
  "voice.cameraPick": "Elegir cámara",
  "voice.cameraUnnamed": "Cámara {n}",

  "share.communities": "Comunidades en el índice",
  "share.communitiesHint":
    "Cuáles de tus comunidades salen en el directorio público. Se publica el nombre, el icono y la descripción; nada de lo que pasa dentro.",
  "share.status.private": "Privada",
  "share.status.unlisted": "Sin listar",
  "share.status.needsStable": "Necesita una dirección estable",
  "share.status.live": "En el índice",

  "explore.discover": "Descubrir",
  "explore.servers": "Servidores",
  "explore.applications": "Aplicaciones",
  "explore.missions": "Misiones",
  "explore.soon": "Pronto",
  "explore.heroTitle": "Explora comunidades",
  "explore.categories": "Categorías",
  "explore.category.home": "Todas",
  "explore.category.games": "Juegos",
  "explore.category.music": "Música",
  "explore.category.entertainment": "Entretenimiento",
  "explore.category.science": "Ciencia y tecnología",
  "explore.category.education": "Enseñanza",
  "explore.category.students": "Estudiantes",
  "explore.category.other": "Otras",
  "community.category": "Categoría",
  "community.categoryHint": "De qué va. Es lo que filtra el directorio público, así que no se adivina por el nombre. Se puede cambiar cuando quieras.",
  "explore.featured": "Destacadas",
  "explore.results": "{count} comunidades",
  "explore.pages": "Páginas de comunidades",
  "explore.pagePrev": "Anterior",
  "explore.pageNext": "Siguiente",
  "explore.pageOf": "Página {page} de {pages}",
  "explore.checkingOnline": "Comprobando qué servidores están en línea…",
  "explore.pageOffline": "Ninguna comunidad de esta página está en línea ahora",
  "explore.search": "Buscar comunidades",
  "explore.noResults": "Nada por aquí",
  "explore.noResultsHint": "Prueba con otras palabras o cambia de categoría.",
  "explore.noDescription": "Sin descripción.",
  "explore.membersShort": "miembros",
  "explore.publicCommunity": "Comunidad pública",
  "explore.openAccess": "Entrada libre",
  "explore.approvalRequired": "Hay que pedir entrar",
  "explore.partialFailure":
    "Algún servidor no contestó, así que puede que falten comunidades en la lista.",

  "direct.title": "Mensajes",
  "direct.searchOrStart": "Buscar o empezar una conversación",
  "direct.friends": "Amigos",
  "direct.friendRequests": "Solicitudes de amistad",
  "direct.messageRequests": "Solicitudes de mensaje",
  "direct.new": "Nueva conversación",
  "direct.empty": "Todavía no hablas con nadie",
  "direct.emptyHint":
    "Busca a alguien por su nombre de usuario y empieza cuando quieras.",
  "direct.start": "Empezar una conversación",
  "direct.attachment": "Archivo adjunto",
  "direct.awaitingApproval": "Esperando a que acepte",
  "direct.search": "Buscar personas",
  "direct.searchPlaceholder": "Nombre o @usuario",
  "direct.noContacts": "Nadie con ese nombre",
  "direct.message": "Enviar mensaje",
  "direct.profileAction": "Enviar mensaje",
  "direct.alreadyFriends": "Ya sois amigos",
  "direct.requestSent": "Solicitud enviada",
  "direct.acceptFriend": "Aceptar solicitud",
  "direct.addFriend": "Añadir amigo",
  "direct.noFriends": "Aún no tienes amigos",
  "direct.noFriendsHint":
    "Añade a alguien y lo tendrás a mano sin buscarlo cada vez.",
  "direct.allFriends": "Todos los amigos — {count}",
  "direct.removeFriend": "Quitar de amigos",
  "direct.removeFriendConfirm": "¿Quitar a {name} de tus amigos?",
  "direct.receivedRequests": "Recibidas",
  "direct.noFriendRequests": "No tienes solicitudes pendientes.",
  "direct.accept": "Aceptar",
  "direct.reject": "Rechazar",
  "direct.sentRequests": "Enviadas",
  "direct.noSentRequests": "No has enviado ninguna solicitud.",
  "direct.messageRequestsHint":
    "Mensajes de gente que no tienes como amiga. Aceptar abre la conversación; rechazar la borra.",
  "direct.noMessageRequests": "No hay solicitudes de mensaje",
  "direct.noMessageRequestsHint":
    "Aquí llega quien te escribe sin ser amigo tuyo.",
  "direct.wantsToMessage": "Quiere escribirte",
  "direct.wantsToMessageNamed": "{name} quiere escribirte.",
  "direct.acceptAndReply": "Aceptar y responder",
  "direct.noSelection": "Elige una conversación",
  "direct.noSelectionHint": "O empieza una nueva desde el botón de arriba.",
  "direct.loadMore": "Ver mensajes anteriores",
  "direct.noMessages": "Aquí no hay nada todavía",
  "direct.noMessagesHint": "Escribe lo primero y {name} lo verá al entrar.",
  "direct.you": "Tú",
  "direct.edited": "editado",
  "direct.reply": "Responder",
  "direct.edit": "Editar",
  "direct.replyingTo": "Respondiendo a",
  "direct.awaitingMessageApproval":
    "{name} todavía no ha aceptado la conversación.",
  "direct.fileTooLarge": "El archivo pasa de {size} MB.",
  "direct.attach": "Adjuntar archivo",
  "direct.placeholder": "Escribe a {name}",
  "direct.send": "Enviar",
  "direct.deleteConfirm": "¿Eliminar este mensaje?",
} as const;

export type MessageKey = keyof typeof es;
